export function useTree(data){
 var cateList=[]
  data.forEach((element) => {
    if (element.pid == 0) {
      cateList.push(element);
    }
  });
  cateList.forEach(element=>{
    element.child=[]
    data.forEach((v) => {
        if(v.pid==element.id){
              element.child.push(v)
        }
    })
  })
  return cateList
}